import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import {
    Box,
    Card,
    DaButton,
    DatePicker,
    InternalGrid,
    Text,
    ScheduleIcon,
    MeterIcon,
} from '@paygreen/paygreen-ui';
import { useUser } from '../../context';
import dayjs from '../../utils/dayjsHelper';
import { startOfMonth, endOfMonth } from '../../utils/constants';
import { IsMobile } from '../../utils/tools';

const FilterTable = ({
    t,
    setEndDate,
    setStartDate,
    endDate,
    startDate,
    hasMinimumDate,
}) => {
    const { user } = useUser();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const searchEndDate = searchParams.get('endDate');
    const searchStartDate = searchParams.get('startDate');

    // we apply as the minimum startDate the first day of the month of subscription of the user
    const minimumStartDate =
        user.createdAt &&
        dayjs(new Date(user.createdAt * 1000)).format('01/MM/YYYY');

    const handleStartDate = (date) => {
        setStartDate(date);
    };

    const handleEndDate = (date) => {
        setEndDate(date);
    };

    return (
        <Card
            colorWab="white10"
            shadowSize="none"
            paddingLateral="xs"
            paddingTop="xs"
            radiusSize="sm"
            blockWidth="xl"
        >
            <InternalGrid
                alignItems="center"
                justifyContent="flex-start"
                hasStaticWidth={false}
                childrenMarginBottom={IsMobile() ? 'sm' : 'md'}
            >
                <InternalGrid
                    displayType="grid"
                    gridTemplateColumns="auto auto "
                    gridGap="md"
                    alignItems="center"
                >
                    <Text textSize="xs">{t('datePicker.from')}</Text>

                    <Box marginRight="sm">
                        <DatePicker
                            locale={t('datePicker.locale')}
                            id="startDate"
                            minimumDate={hasMinimumDate ? minimumStartDate : null}
                            maximumDate={endDate || endOfMonth}
                            fieldSize="sm"
                            blockWidth="sm"
                            resetDate={endDate}
                            value={startDate || startOfMonth}
                            onChange={handleStartDate}
                            icon={<ScheduleIcon />}
                        />
                    </Box>
                </InternalGrid>

                <InternalGrid
                    displayType="grid"
                    gridTemplateColumns="auto auto"
                    gridGap="md"
                    alignItems="center"
                >
                    <Text textSize="xs">{t('datePicker.to')}</Text>

                    <Box marginRight="sm">
                        <DatePicker
                            locale={t('datePicker.locale')}
                            id="endDate"
                            minimumDate={startDate || startOfMonth}
                            maximumDate={endOfMonth}
                            fieldSize="sm"
                            blockWidth="sm"
                            resetDate={startDate}
                            value={endDate || endOfMonth}
                            onChange={handleEndDate}
                            icon={<ScheduleIcon />}
                        />
                    </Box>
                </InternalGrid>

                {!IsMobile() && (searchEndDate || searchStartDate) ? (
                    <Link to={`/?${searchParams.toString()}`}>
                        <DaButton
                            buttonSize="sm"
                            buttonStyle="line"
                            gradient="theme"
                            colorTheme="quaternary"
                            icon={<MeterIcon />}
                        >
                            {t('shopDonations.dashboardLink')}
                        </DaButton>
                    </Link>
                ) : null}
            </InternalGrid>
        </Card>
    );
};

FilterTable.propTypes = {
    endDate: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    setEndDate: PropTypes.func.isRequired,
    setStartDate: PropTypes.func.isRequired,
    hasMinimumDate: PropTypes.bool,
};

FilterTable.defaultProps = {
    hasMinimumDate: true,
};

export default withTranslation('common')(FilterTable);
